import { Pressable, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { DEMO_ACCOUNTS_BY_KEY, type DemoAccountKey } from '@perdiem/trpc/demo-accounts';

export function DemoModeBanner({
  demoAccountKey,
  compact = false,
  onTryAnotherDemo,
  onSignUpNow,
  onDismiss,
}: {
  demoAccountKey: DemoAccountKey | null;
  compact?: boolean;
  onTryAnotherDemo?: () => void;
  onSignUpNow?: () => void;
  onDismiss?: () => void;
}) {
  if (!demoAccountKey) return null;

  const account = DEMO_ACCOUNTS_BY_KEY[demoAccountKey];

  return (
    <View className="rounded-2xl border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 px-4 py-3">
      <View className="flex-row items-start justify-between gap-3">
        <View className="flex-1">
          <Text className="text-xs font-semibold uppercase tracking-[0.18em] text-amber-700 dark:text-amber-400">
            Demo Mode
          </Text>
        </View>
        {onDismiss ? (
          <Pressable
            accessibilityLabel="Dismiss demo mode banner"
            onPress={onDismiss}
            className="rounded-full p-1"
          >
            <Ionicons name="close" size={16} color="#b45309" />
          </Pressable>
        ) : null}
      </View>
      <Text className="mt-1 text-sm font-semibold text-amber-950 dark:text-amber-200">
        {account.title}
      </Text>
      <Text className="mt-2 text-sm leading-5 text-amber-800 dark:text-amber-300">
        {compact ? account.summary : `${account.summary} Illustrative data, refreshed regularly. Everything in this account is read-only.`}
      </Text>
      {(onTryAnotherDemo || onSignUpNow) && (
        <View className="mt-3 flex-row flex-wrap gap-3">
          {onTryAnotherDemo && (
            <Pressable onPress={onTryAnotherDemo}>
              <Text className="text-sm font-semibold text-amber-900 dark:text-amber-300">Try another demo</Text>
            </Pressable>
          )}
          {onSignUpNow && (
            <Pressable onPress={onSignUpNow}>
              <Text className="text-sm font-semibold text-amber-900 dark:text-amber-300">Start 14 days free</Text>
            </Pressable>
          )}
        </View>
      )}
    </View>
  );
}
